module.exports = __webpack_public_path__ + "img/FenMian.146e4614.jpg";